'use client';

export const useSetWindowLocation = () => {
  return (redirect: string) => {
    window.location.href = redirect;
  };
};
